import React from "react";
import styled from "styled-components";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { H3, P, Button } from "../../common";
import { rejig2020Title } from "../Tile/Tile";

const Styled = {};
Styled.TextLink = styled.div`
  padding: 8vh 0;
  display: flex;
  justify-content: center;
  align-items: center;
  //margin: 0 0 4rem 0;
  &.partOfPair {
    //display: inline-flex;
    //width: 49vw;
  }
  &.single {
    //width: 100vw;
  }
  @media only screen and (max-width: 733px) {
    //margin: 0 0 5rem 0;
    &.partOfPair {
      //width: 100vw;
    }
  }
`;

const ContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 50px;
  text-align: center;
  &.partOfPair {
    width: 500px;
  }
  &.single {
    width: 75vw;
    max-width: 1000px;
  }
  @media only screen and (max-width: 733px) {
    width: 90vw !important;
  }
`;

export const Text = ({ topic }) => {
  const { title, topicPreview, chapter, slug, partOfPair } = topic;
  const _chapter =
    chapter && chapter !== "none" ? chapter.toLowerCase() + `/` : "";
  const path = "/" + _chapter + slug;
  //console.log("topic from Text.js: ", topic),path;
  return (
    // <TextLinkWrap style={partOfPair ? {display: "inline-flex", width: "49vw"} : {}}>
    <Styled.TextLink className={partOfPair ? "partOfPair" : "single"}>
      <ContentWrap className={partOfPair ? "partOfPair" : "single"}>
        {title && <H3>{rejig2020Title(title)}</H3>}
        <P fluid>
          {topicPreview && documentToReactComponents(topicPreview.json)}
        </P>

        {chapter && slug && (
          <Button to={path} target="self">
            Learn More
          </Button>
        )}
      </ContentWrap>
    </Styled.TextLink>
  );
};
